import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import PageMeta from '../components/PageMeta';

// WO-10: /tcg/<TCGplayer productId> -> the card or product page that carries it (/card/base1-4, /product/me5.etb).
const TcgRedirect = () => {
  const { tcgId } = useParams();
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL || '';
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    fetch(`${apiUrl}/api/tcg/${encodeURIComponent(tcgId || '')}`, { signal: ctrl.signal })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((data) => {
        if (data && data.path) navigate(data.path, { replace: true });
        else setMissing(true);
      })
      .catch((e) => { if (e.name !== 'AbortError') setMissing(true); });
    return () => ctrl.abort();
  }, [apiUrl, tcgId, navigate]);

  if (!missing) return <div className="py-12 text-cream/70">Redirecting…</div>;
  return (
    <div className="py-12 text-cream">
      <PageMeta title="Not found | Lilycove" />
      <h1 className="text-2xl text-purple mb-2">Not on Lilycove yet</h1>
      <p className="text-cream/70">TCGplayer product {tcgId} is not linked to a page here. <Link to="/" className="text-skyblue">Back to home</Link></p>
    </div>
  );
};

export default TcgRedirect;
